import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

// modules
const user = process.env.VUE_APP_API_ENV === 'fake' ?
    require('./modules/fake/user').default :
    require('./modules/user').default
const portfolio = process.env.VUE_APP_API_ENV === 'fake' ?
    require('./modules/fake/portfolio').default :
    require('./modules/portfolio').default
const people = process.env.VUE_APP_API_ENV === 'fake' ?
    require('./modules/fake/people').default :
    require('./modules/people').default
const attachment = process.env.VUE_APP_API_ENV === 'fake' ?
    require('./modules/fake/attachment').default :
    require('./modules/attachment').default
const address = process.env.VUE_APP_API_ENV === 'fake' ?
    require('./modules/fake/address').default :
    require('./modules/address').default
const company = process.env.VUE_APP_API_ENV === 'fake' ?
    require('./modules/fake/company').default :
    require('./modules/company').default


const offering = require('./modules/offering').default
const todo = require('./modules/todo').default
const team = require('./modules/team').default
const charts = require('./modules/charts').default
const arbiter = require('./modules/arbiter').default
const temp = require('./modules/temp').default
const infobox = require('./modules/infobox').default
const investment = require('./modules/investment').default
const file = require('./modules/fileupload').default
const role = require('./modules/role').default;
const diligence = require('./modules/diligence').default;
const diligence_stage = require('./modules/diligence_stage').default;
const transaction_type = require('./modules/transaction_type').default;
const workspace = require('./modules/workspace').default;
const newsFeed = require('./modules/newsFeed').default;
const suggestions = require('./modules/suggestions').default;
const referrer = require('./modules/referrer').default;
const notifications = require('./modules/notifications').default;
const accountPlans = require('./modules/accountPlans').default;
const workspacePlans = require('./modules/workspacePlan').default;
const contacts = require('./modules/contacts').default;
const lpAllocations = require('./modules/lpAllocations').default;
const dashboardCoordinates = require('./modules/dashboardCoordinates').default;
const rounds = require('./modules/rounds').default;
const checklist = require('./modules/checklist').default;
// attach plugin
Vue.use(Vuex)

// persist storage for vuex
const localStorage = new VuexPersist({
    key: 'fiifi',
    storage: window.localStorage,
    reducer: state => ({
        user: state.user
    })
})

const sessionStorage = new VuexPersist({
    key: 'fiifi',
    storage: window.sessionStorage,
    reducer: state => ({
        portfolio: state.portfolio,
        company: state.company,
        people: state.people,
        attachment: state.attachment,
        address: state.address,
        investment: state.investment,
        file: state.file,
        offering: state.offering,
        todo: state.todo,
        role: state.role,
        team: state.team,
        diligence: state.diligence,
        diligence_stage: state.diligence_stage,
        transaction_type: state.transaction_type,
        workspace: state.workspace,
        newsFeed: state.newsFeed,
        suggestions: state.suggestions,
        referrer: state.referrer,
        notifications: state.notifications,
        accountPlans: state.accountPlans,
        workspacePlans: state.workspacePlans,
        contacts: state.contacts,
        lpAllocations: state.lpAllocations,
        dashboardCoordinates: state.dashboardCoordinates,
        rounds: state.rounds,
        checklist: state.checklist
    })
})

export default new Vuex.Store({
    plugins: [localStorage.plugin, sessionStorage.plugin],
    modules: { // load modules as needed
        user,
        portfolio,
        charts,
        arbiter,
        company,
        people,
        temp,
        attachment,
        address,
        infobox,
        investment,
        file,
        offering,
        todo,
        team,
        role,
        diligence,
        diligence_stage,
        transaction_type,
        workspace,
        newsFeed,
        suggestions,
        referrer,
        notifications,
        accountPlans,
        contacts,
        workspacePlans,
        lpAllocations,
        dashboardCoordinates,
        rounds,
        checklist
    }
})